import "./fonts/font.css";
import './App.css';


import Homepage from './components/HomePage';
import GamePage from "./components/GamePage";
import SimpleExplicationPage from "./components/explanation_pages/simpleExplanationPage";
import GameConfigurator from "./components/GameConfigurator";
import Login from "./components/Login";
import { AuthProvider } from "./components/authentication/AuthContext";
import ProtectedRoute from "./components/authentication/ProtectedRoute";
import Profile from "./components/Profile";
import HeaderAdmin from "./components/HeaderAdmin";
import AnimatorForm from "./components/forms/AnimatorForm";
import TerrainTestPage from "./components/terrain_test/TerrainTestPage";

import MapComponent from "./components/graph_pages/graph_components/MapFootprint";
import WorkshopBuilder from "./components/builder/WorkshopBuilder";
import ConfigEditor from "./components/builder/ConfigEditor";
import PageComposer from "./components/builder/PageComposer";
import DecisionEditor from "./components/builder/DecisionEditor";
import WorkshopGraph from "./components/builder/WorkshopGraph";


import { Fragment, useEffect, useState } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  useNavigate,
  useParams,
  useLocation
} from "react-router-dom";


const GamePageWrapper = () => {
  const { gameId } = useParams();  // Récupérer le gameId depuis l'URL
  return (<GamePage gameId={gameId} />);
};

const router = createBrowserRouter([
  {
    path: "/",
    element: 
    <ProtectedRoute>
      <Home/>
    </ProtectedRoute>,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/game_test",
    element: <SimpleExplicationPage/>,
  },
  {
    // Route de test isolee : visualisation 3D d'un extrait de MNT (IGN).
    // Non liee dans le menu, aucun lien avec la base ou les ateliers.
    path: "/terrain-test",
    element: <TerrainTestPage/>,
  },
  {
    path: "/game/:gameId", // Route dynamique pour le gameId
    element: <GamePageWrapper />,
  },
  {
    path: "/game_config/:gameConfigId", // Route dynamique pour le gameId
    element: 
    <ProtectedRoute>
      <GameConfiguratorPage />
    </ProtectedRoute>,
  },
  {
    path: "/profile", // Route vers le form pour ajouter des éléments
    element:
    <ProtectedRoute>
      <ProfileHomePage />
    </ProtectedRoute>,
  },
  {
    path: "/map", // Route vers le form pour ajouter des éléments
    element: <MapComponent  />
  },
  {
    path: "/animator_form",
    element:
    <ProtectedRoute>
      <AnimatorFormPage />
    </ProtectedRoute>,
  },
  {
    path: "/builder",
    element:
    <ProtectedRoute>
      <BuilderPage component={WorkshopBuilder} />
    </ProtectedRoute>,
  },
  {
    path: "/builder/config/:configId",
    element:
    <ProtectedRoute>
      <BuilderPage component={ConfigEditor} />
    </ProtectedRoute>,
  },
  {
    path: "/builder/config/:configId/graph",
    element:
    <ProtectedRoute>
      <BuilderPage component={WorkshopGraph} />
    </ProtectedRoute>,
  },
  {
    path: "/builder/page/:pageId",
    element:
    <ProtectedRoute>
      <BuilderPage component={PageComposer} />
    </ProtectedRoute>,
  },
  {
    // MÊME ÉCRAN, ATELIER NOMMÉ. Une page ne se compose bien que dans le
    // contexte d'un atelier : c'est lui qui porte les scores qu'elle affiche et
    // le territoire qu'elle survole. Le composeur sait le déduire quand un seul
    // atelier emploie la page ; cette forme le désigne quand on vient d'un
    // atelier précis, et rend le lien partageable.
    path: "/builder/config/:configId/page/:pageId",
    element:
    <ProtectedRoute>
      <BuilderPage component={PageComposer} />
    </ProtectedRoute>,
  },
  {
    // Édition d'une étape d'un module « territoire 3D », en plein écran.
    // Servie par le composeur lui-même — et non par un composant séparé — pour
    // qu'il garde la propriété du brouillon de la page : une route autonome
    // obligerait à sauvegarder côté serveur avant chaque édition d'étape, ou à
    // trimballer le brouillon dans le routeur.
    path: "/builder/page/:pageId/step/:stepId",
    element:
    <ProtectedRoute>
      <BuilderPage component={PageComposer} />
    </ProtectedRoute>,
  },
  {
    path: "/builder/config/:configId/page/:pageId/step/:stepId",
    element:
    <ProtectedRoute>
      <BuilderPage component={PageComposer} />
    </ProtectedRoute>,
  },
  {
    path: "/builder/decision/:decisionId",
    element:
    <ProtectedRoute>
      <BuilderPage component={DecisionEditor} />
    </ProtectedRoute>,
  },
]);



function Home() {
  const navigate = useNavigate();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <Homepage/>
        </div>
      </div>
    </Fragment>
  );
}

function GameConfiguratorPage() {
  const { gameConfigId } = useParams();

  // MÊME CADRE QUE LE RESTE DE L'ESPACE ANIMATEUR (cf. `BuilderPage`) : cet
  // écran s'ouvre depuis /profile et y renvoie. Il flottait auparavant sur une
  // page blanche sans en-tête, dans deux div sans aucun style.
  return (
    <Fragment>
      <HeaderAdmin />
      <div style={{ minHeight: "calc(100vh - 70px)", background: "#f8fafc" }}>
        <GameConfigurator gameConfigId={gameConfigId}/>
      </div>
    </Fragment>
  );
}

function ProfileHomePage() {

  return (
    <Fragment>
      <HeaderAdmin></HeaderAdmin>
      <Profile></Profile>
    </Fragment>
  );
}

function AnimatorFormPage() {
  return (
    <Fragment>
      <HeaderAdmin></HeaderAdmin>
      <AnimatorForm></AnimatorForm>
    </Fragment>
  );
}

function BuilderPage({ component: Component }) {
  return (
    <Fragment>
      <HeaderAdmin />
      <div style={{ minHeight: "calc(100vh - 70px)", background: "#f8fafc" }}>
        <Component />
      </div>
    </Fragment>
  );
}





function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;